/* 🤖 this file was generated by svg-to-ts */
export var spxIconArrowDown01Sharp = {
    name: 'arrow_down_01_sharp',
    data: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.25 9.6L11.29 14.64C11.63 14.98 11.79 15.14 12 15.14C12.21 15.14 12.37 14.98 12.71 14.64L17.75 9.6\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"
};
